import React from "react";
import {
  StyledBodyInternalGrade,
  StyledColumnContainer,
} from "./InternalGradeView.styled";
import { Loader } from "../../../../../components/core/Loader/Loader";
import {
  GRADE_LABEL,
  INTERNAL_GRADE_START_LABEL,
  JOB_FAMILY_LABEL,
  PATH_LABEL,
  SUBGRADE_LABEL,
} from "../../../../../constants/Dictionary";
import { IconManager } from "../../../../../components/core/IconManager/IconManager";
import { FontWeightEnum, IconSizeEnum } from "../../../../../types/AppTypes";
import { ReactComponent as ArrowCircleRightIcon } from "../../../../../icons/arrowCircleRight.svg";
import { TextBox } from "../../../../../components/TextBoxGrid/TextBoxGrid.component";
import { StyledWorkInformationTitle } from "../Resume.styled";
import { BodyTyp } from "../../../../../components/Typography/Typography";
import { theme } from "../../../../../constants/StyledComponents";
import { internalGradeType } from "../../../../../types/api/collaborators.type";

interface internalGradeProps {
  startInternalGrade: internalGradeType;
  isComparisonComponent?: boolean;
}

export const InternalGradeView = ({
  startInternalGrade,
  isComparisonComponent = false,
}: internalGradeProps) => {
  return (
    <div className="page-break">
      <StyledWorkInformationTitle>
        <IconManager size={IconSizeEnum.SMALL} color={theme.colors.black}>
          <ArrowCircleRightIcon />
        </IconManager>
        <BodyTyp variant="2" fontWeight={FontWeightEnum.SEMIBOLD}>
          {INTERNAL_GRADE_START_LABEL}
        </BodyTyp>
      </StyledWorkInformationTitle>
      <Loader loading={false}>
        <StyledBodyInternalGrade $isComparisonComponent={isComparisonComponent}>
          <div className="internal-grade-bordered-container">
            <StyledColumnContainer
              $isComparisonComponent={isComparisonComponent}
            >
              <TextBox
                label={JOB_FAMILY_LABEL}
                text={startInternalGrade.jobFamilies}
              />
              <TextBox label={GRADE_LABEL} text={startInternalGrade.grade} />
              <TextBox label={PATH_LABEL} text={startInternalGrade.path} />
              <TextBox
                label={SUBGRADE_LABEL}
                text={startInternalGrade.subGrade}
              />
            </StyledColumnContainer>
          </div>
        </StyledBodyInternalGrade>
      </Loader>
    </div>
  );
};
